import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const AddGroup = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  cursor: pointer;
`;
const Status = styled.div`
  max-width: 453px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  align-items: flex-start;
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-12);
`;

const GroupItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  width: 100%;
`;

const SortableGroupWrapper = styled.div<{
  isDragging?: boolean;
  cssTransform?: string;
  cssTransition?: string;
}>`
  transform: ${({ cssTransform }) => cssTransform || 'none'};
  transition: ${({ cssTransition }) => cssTransition || 'none'};
  opacity: ${({ isDragging }) => (isDragging ? 0.4 : 1)};
  width: 100%;
`;

const StatusRow1 = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-8);
  ${mobile_xl(css`
    padding-inline: var(--space-5);
  `)}
`;

const draggingStyle = {
  background: 'var(--background-primary)',
  borderRadius: 'var(--border-radius-8)',
  boxShadow: 'var(--shadow-card-hover)',
  border: '0.5px solid var(--border-primary)'
};

const normalStyle = {
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  borderRadius: 0
};

const StatusRows = styled.div<{ isDragging?: boolean }>`
  ${AlignCenter}
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  justify-content: space-between;
  gap: var(--space-10);
  .active-state {
    border-radius: var(--border-radius-6);
    background-color: var(--background-muted);
  }
  .more-icon:hover {
    background-color: var(--background-muted);
  }
  background: ${(props) => (props.isDragging ? draggingStyle.background : normalStyle.background)};
  border-radius: ${(props) => (props.isDragging ? draggingStyle.borderRadius : normalStyle.borderRadius)};
  box-shadow: ${(props) => (props.isDragging ? draggingStyle.boxShadow : normalStyle.boxShadow)};
  border: ${(props) => (props.isDragging ? draggingStyle.border : normalStyle.border)};

  ${mobile_xl(css`
    padding-inline: var(--space-8);
  `)}
`;
const Line = styled.div`
  width: 100%;
  position: relative;
  &:hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
    svg {
      opacity: 1;
    }
  }
  ${mobile_xl(css`
    &:hover {
      background-color: unset;
      border-radius: var(--border-radius-0);
    }
  `)}
`;

export { AddGroup, Status, StatusRows, Line, StatusRow1, SortableGroupWrapper, GroupItems };
